import { CREDIT_BLOTTER_PREFIX } from '@src/containers/Blotters/Credit/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy credit tabs into credit blotter panel params. */
export function migrateCreditBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyCreditTabs = config.tabs?.[CREDIT_BLOTTER_PREFIX];
  if (legacyCreditTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyCreditTabs,
    blotterType: 'creditBlotter',
  });
}
